// Routes Imports
import Pages from "./Pages";

// Merge Routes
const customRoutes = [...Pages];

export { customRoutes };